module.exports = __webpack_public_path__ + "img/awards-zhTc.fea314bb.png";